/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable shopify/jquery-dollar-sign-reference */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable promise/catch-or-return */
/* eslint-disable no-empty */
/* eslint-disable promise/always-return */
/**
 * Custom methods
 * -----------------------------------------------------------------------------
 *
 * @namespace custom
 */

// media queries in Javascript => http://wicky.nillia.ms/enquire.js/
import enquire from 'enquire.js';
// detect if a device is mouseOnly, touchOnly, or hybrid => http://detect-it.rafrex.com/
import detectIt from 'detect-it';
import axios from 'axios';
import subscribe from 'klaviyo-subscribe';
import scrollMonitor from 'scrollmonitor';
import Flickity from 'flickity';

var customMethods = {
	data: function data() {
		return {
			// your data here
			iscompareLoaded: false,
			compareProducts: [],
			compareProDetails: {},
			comparePropArray: []
		};
	},


	methods: {
		_initCustomMethods: function _initCustomMethods() {
			// custom JS code
			app._checkScript();
			//app._customTriggers();

			// const top = $('#brandList').position();      
			window.addEventListener('scroll', app._scrollYSearch);
			app._scrollYSearch();
			window.addEventListener('scroll', app._scrollYCollection);
			app._scrollYCollection();

			// eslint-disable-next-line func-style
			var detectNetwork = function detectNetwork() {
				var effectiveType = navigator.connection.effectiveType;
				// console.log('Network:', effectiveType);
			};
			if (navigator.connection) {
				navigator.connection.addEventListener('change', detectNetwork);
			}
			if (navigator.onLine) {
				window.addEventListener('offline', function (e) {
					console.log('Status: Offline');
				});
				window.addEventListener('online', function (e) {
					console.log('online');
				});
			}

			app._menu();
			app._scrollTop();
			app._setCampaingCode();
			app._openReviewModal();
			app._stickybrands();
			app._adaCompliance();

			if ($('.simpAskQuestion-Qcontent').length > 0) {
				$('.simpAsk-title-container').hide();
			}

			// $('[action="/search"]').find('[name="searchInput"]').val('');
			$('body').on('click', '[data-ajaxAdd]', function (event) {
				event.preventDefault();
				var variantId = $(event.currentTarget).attr('data-default-variant-id');
				app._addToCart(variantId, event);
			});

			$('body').on('click', '[data-wishlistAdd]', function (event) {
				var proHandle = $(event.currentTarget).attr('data-handle');
				app._selectWishlistProduct(proHandle);
				$('#wishlistModal').modal({ show: true });
			});

			$('[action="/search"]').on('submit', function (event) {
				var formValue = $.trim($(this).find('[name="searchInput"]').val());
				console.log(formValue);
				if (formValue.length <= 0) {
					event.preventDefault();
				}
			});

			$('body').on('click', '[name="checkout"]', function (event) {
				var cartItemArray = [];
				$(app.cart.items).each(function (index, item) {
					var itemTitle = item.sku + " " + item.title;
					var itemPrice = app._formatMoney(item.line_price).replace('$', '').replace(',', '');
					itemPrice = Number(itemPrice);
					var totalPrice = app._formatMoney(app.cart.total_price).replace('$', '').replace(',', '');
					totalPrice = Number(totalPrice);
					var itemVariant = item.variant_id == item.id ? item.title : item.variant_options[0] == 'Default Title' ? item.title : item.variant_options[0];
					cartItemArray.push({
						id: item.InternalId,
						name: itemTitle,
						price: itemPrice,
						brand: item.vendor,
						category: item.category,
						dimension5: item.ItemspecialCategory,
						dimension6: item.Itemcategory,
						dimension7: item.ItemsubCategory,
						variant: itemVariant,
						//dimension8: itemTitle,
						//dimension9: item.InternalId,
						//metric3: app._formatMoney(item.line_price).replace('$', ''),
						//dimension11: item.vendor,
						position: index,
						//metric2: item.quantity,
						item_count: app.cart.item_count,
						total_cost: totalPrice
					});
				});
				dataLayer.push({
					event: 'checkout',
					ecommerce: {
						checkout: {
							products: cartItemArray
						}
					}
				});
			});
		},
		_toogleCollapse: function _toogleCollapse(el) {
			var $el = $("#" + el);
			if ($el.hasClass('show')) {
				$("[aria-controls=\"" + el + "\"]").removeClass('.collapsed');
				$("[aria-controls=\"" + el + "\"]").attr('aria-expanded', false);
				$el.removeClass('show');
			} else {
				$("[aria-controls=\"" + el + "\"]").addClass('collapsed');
				$("[aria-controls=\"" + el + "\"]").attr('aria-expanded', true);
				$el.addClass('show');
			}
		},
		_scrollYSearch: function _scrollYSearch() {
			var scrollP = window.scrollY;
			var isSearchPage = $('body').hasClass('template-search');
			if (isSearchPage === true) {
				// eslint-disable-next-line func-style
				var unloadEvent = function unloadEvent() {
					localStorage.setItem("scrollPos", scrollP);
					// console.log("scroll last==>",localStorage.scrollPos);
				};
				window.addEventListener("beforeunload", unloadEvent);

				setTimeout(function () {
					if (localStorage.scrollPos) {
						// console.log("scroll load==>",getScrollVal);
						$("html, body").scrollTop(localStorage.getItem("scrollPos"));
					}
				}, 1500);
				setTimeout(function () {
					localStorage.removeItem("scrollPos");
				}, 4000);
			}
		},
		_scrollYCollection: function _scrollYCollection() {
			var scrollXP = window.scrollY;
			var isCollectionPage = $('body').hasClass('template-collection');
			// console.log("isCollectionPage==>", isCollectionPage);

			if (isCollectionPage === true) {

				var unloadEvent = function unloadEvent(e) {
					localStorage.setItem("scrollSearchPos", scrollXP);
					// console.log("scroll last==>",localStorage.scrollSearchPos);
				};
				window.addEventListener("beforeunload", unloadEvent);

				setTimeout(function () {
					if (localStorage.scrollSearchPos) {
						var getScrollVal = localStorage.getItem("scrollSearchPos");
						// console.log("scroll load==>",getScrollVal);
						$("html, body").scrollTop(localStorage.getItem("scrollSearchPos"));
					}
				}, 1500);
				setTimeout(function () {
					localStorage.removeItem("scrollSearchPos");
				}, 4000);
			}
		},
		_updateHawkItem: function _updateHawkItem() {
			$('[data-wishlistAdd]').each(function (index, item) {
				var itemhandle = $(item).attr('data-handle');
				if (app.wishListedProductsHandles.includes(itemhandle)) {
					$(item).find('.rbh-icon-heart').addClass('added');
				}
			});
		},
		_customSaleModel: function _customSaleModel(event) {
			var $btnTarget = $(event.currentTarget);
			var modelTitle = $btnTarget.attr('data-title');
			var modelDesc = $btnTarget.attr('data-desc');
			$('#showsaleDetails h4').html(modelTitle);
			$('#showsaleDetails .modal-text').html(modelDesc);
		},
		_menu: function _menu() {
			$('[data-menuoption]').on('click', function () {
				$('[data-submenudrawer]').attr('style', '');
			});

			$('[data-menuBack]').click(function (event) {
				var $drawerElement = $(this).closest('[data-submenudrawer]');
				$drawerElement.css('left', '100%');
				setTimeout(function () {
					$drawerElement.removeClass('show');
				}, 500);
			});

			// smooth scroll for template-brand page
			$('[data-brand-link]').on('click', function (e) {
				var target = $(e.target).attr('href');
				if (target.length) {
					e.preventDefault();
					$('html').animate({
						scrollTop: $(target).offset().top - 100
					}, 400);
				}
			});

			//   const element = document.querySelector('.site-header');
			//   const headerHeight = element.offsetHeight;
			//   $('.menu-dropshadow').css('top', headerHeight);
		},
		_openReviewModal: function _openReviewModal() {
			if (window.location.href.indexOf('for=review_modal') > -1) {
				setTimeout(function () {
					$('[data-reviewmodal]').addClass('show');
					app._showReviewForm();
				}, 1000);
			}
		},
		_redirectOptions: function _redirectOptions(event) {
			var value = $(event.currentTarget).val();

			/* if (app.quickShop.isQuickshopModalOpen === true) {
			  $('[data-customColor]').text($(event.currentTarget).next().attr('data-original-title'));
			  app._viewQuickShop(value, '', event);
			  setTimeout(() => {
				const $carousel = $('.modal-quickshop').find('[data-flickity]');
				const $carouselNav = $('.modal-quickshop').find('[data-carousel-nav]');
				// re-init tooltips but only for desktop
				if (!detectIt.hasTouch) {
				  $('[data-toggle="tooltip"]').tooltip();
				}
				  if ($carousel.length > 0) {
				  const carouselOptions = $carousel.data('flickity');
				  const flktyMain = new Flickity($carousel[0], carouselOptions);
				  const cellElements = flktyMain.getCellElements();
				  flktyMain.resize();
				}
				  if ($carouselNav.length > 0) {
				  const carouselNavOptions = $carouselNav.data('flickity');
				  const flktyNav = new Flickity($carouselNav[0], carouselNavOptions);
				  const cellElements = flktyNav.getCellElements();
				  flktyNav.resize();
				}
			  }, 1000);
			} else {*/
			location.href = "/products/" + value;
			// }
		},
		_viewmore: function _viewmore() {
			$('html, body').animate({
				scrollTop: 0
			}, 1000);
		},
		_scrollTop: function _scrollTop() {
			window.addEventListener('scroll', function () {
				var windowScrollY = window.scrollY;
				if (windowScrollY > 10) {
					$('[back-top]').addClass('d-block');
				} else {
					$('[back-top]').removeClass('d-block');
				}
			});
		},
		_stickybrands: function _stickybrands() {

			if ($('.brand-sticky').length <= 0) {
				return;
			}
			var stickyTop = $('.brand-sticky').offset().top;
			$(window).scroll(function () {
				var scroll = $(window).scrollTop();
				if (scroll >= stickyTop) {
					$('.brand-sticky').addClass('fixed-top');
				} else {
					$('.brand-sticky').removeClass('fixed-top');
				}
			});
		},


		// add scripts files

		// _klaviyoScript: function _klaviyoScript() {
		// 	if (app.allScript.indexOf('company_id=HBuSDn') === -1) {
		// 		var script = document.createElement('script');
		// 		script.type = 'text/javascript';
		// 		script.defer = true;
		// 		script.async = true;
		// 		script.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=HBuSDn&shop=riverbendhomedev.myshopify.com";
		// 		document.getElementsByTagName('head')[0].appendChild(script);
		// 		app._checkScript();
		// 	}
		// },
		// _klaviyoScript2: function _klaviyoScript2() {
		// 	if (app.allScript.indexOf('company_id=VN8sdh') === -1) {
		// 		var script = document.createElement('script');
		// 		script.type = 'text/javascript';
		// 		script.defer = true;
		// 		script.async = true;
		// 		script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=VN8sdh&shop=riverbendhomedev.myshopify.com';
		// 		document.getElementsByTagName('head')[0].appendChild(script);
		// 	}
		// },
		_isInViewport: function _isInViewport(x) {
			if ($(x).length) {
				var elementTop = $(x).offset().top;
				var elementBottom = elementTop + $(x).outerHeight();
				var viewportTop = $(window).scrollTop();
				var viewportBottom = viewportTop + $(window).height();
				return elementBottom > viewportTop && elementTop < viewportBottom;
			}
		},
		// _customTriggers: function _customTriggers() {
		//   $(window).on('resize scroll', function () {
		//     if (document.querySelectorAll('[data-footer-top]').length > 0) {
		//       if (app._isInViewport('[data-footer-top]')) {
		//         app._klaviyoScript();
		//         app._klaviyoScript2();
		//       }
		//     }
		//   });
		// },
		_getComparePro: function _getComparePro() {
			var availableProducts = localStorage.getItem('compareProducts');
			app.comparePropArray = [];
			app.iscompareLoaded = false;
			if (availableProducts !== undefined && availableProducts !== null && availableProducts.length > 0) {
				app.compareProducts = availableProducts.split(',');
				$('[name="compare_product"]').prop('checked', false);
				$(app.compareProducts).each(function (index, handle) {
					$("[name=\"compare_product\"][value=\"" + handle + "\"]").prop('checked', true);
					axios.get("/products/" + handle + "?view=json").then(function (response) {
						app.comparePropArray.push(response.data);
					}).catch(function (error) {
						throw error;
					});
				});
				setTimeout(function () {
					app.iscompareLoaded = true;
					if (app.currentTemplate === 'collection') {
						$('[data-compareModal]').addClass('show');
					}
				}, 1000);
			} else {
				$('[data-compareModal]').removeClass('show');
				$('[name="compare_product"]').prop('checked', false);
				app.iscompareLoaded = true;
			}
		},
		_compareProUpdate: function _compareProUpdate(event, handle) {
			var $target = $(event.currentTarget);
			if ($target.prop('checked') === true) {
				app._addCompareProduct(handle);
			} else {
				app._removeCompareProduct(handle);
			}
		},
		_addCompareProduct: function _addCompareProduct(product) {
			var availableProducts = localStorage.getItem('compareProducts');
			if (availableProducts !== undefined && availableProducts != null) {
				app.compareProducts = availableProducts.split(',');
				if (app.compareProducts.length < 3) {
					availableProducts += "," + product;
				} else {
					$("[name=\"compare_product\"][value=\"" + product + "\"]").prop('checked', false);
					app._snotifyMessage('Only 3 products allowed!', 'Product Limit');
				}
			} else {
				availableProducts = product;
			}
			app.compareProducts = availableProducts.split(',');
			localStorage.setItem('compareProducts', availableProducts);
			app._getComparePro();
		},
		_removeCompareProduct: function _removeCompareProduct(handle) {
			app.iscompareLoaded = false;
			var availableProducts = localStorage.getItem('compareProducts');
			if (availableProducts !== undefined && availableProducts !== null) {
				if (availableProducts.indexOf(handle + ",") > -1) {
					availableProducts = availableProducts.replace(handle + ",", '');
				} else if (availableProducts.indexOf("," + handle) > -1) {
					availableProducts = availableProducts.replace("," + handle, '');
				} else {
					availableProducts = availableProducts.replace("" + handle, '');
				}
				if (availableProducts.length > 0) {
					app.compareProducts = availableProducts.split(',');
					localStorage.setItem('compareProducts', availableProducts);
				} else {
					app.compareProducts = [];
					localStorage.removeItem('compareProducts');
				}
				app._getComparePro();
			}
		},
		_clearcompare: function _clearcompare() {
			localStorage.removeItem('compareProducts');
			app._getComparePro();
		},
		_newsletterRegister: function _newsletterRegister(event, listId) {
			var $registerForm = $(event.currentTarget).closest('form');
			var email = $.trim($registerForm.find('[data-email]').val());
			if (email.length > 0) {
				var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
				if (regex.test(email)) {
					subscribe(listId, email).then(function (response) {
						console.log(response);
						if (response.success === true) {
							app._snotifyMessageSuccess('Success!', 'You are subscribed to our mailing list.');
							pintrk('track', 'lead', {
								lead_type: 'Newsletter'
							});
						} else if (response.errors.length > 0) {
							app._snotifyMessage('Error!', response.errors[0]);
						}
					});
				} else {
					app._snotifyMessage('Provide valid email address!', 'Invalid Email!');
				}
			} else {
				app._snotifyMessage('Email is Blank!', 'Invalid Email!');
			}
		},
		_scrollToReview: function _scrollToReview() {
			if ($('#headingFive').length > 0) {
				$('html, body').animate({
					scrollTop: $('#headingFive').offset().top - 50
				}, 2000);
				if ($('[data-reviewmodal]').hasClass('show') === false) {
					$('#headingFive').find('.open-close').trigger('click');
				}
			}
		},
		_setCampaingCode: function _setCampaingCode() {
			var href = window.location.href;
			if (href.includes('utm_source') || href.includes('utm_campaign')) {
				href = href.split('?');
				var utmCode = href[1].split('&');
				utmCode.forEach(function (x) {
					var data = x.split('=');
					localStorage.setItem(data[0], data[1]);
				});
			}
		},
		_getCampaingCode: function _getCampaingCode() {
			var utm_source = localStorage.getItem('utm_source');
			var utm_campaign = localStorage.getItem('utm_campaign');

			if (utm_source !== undefined) {
				$('[data-utm_source]').val(utm_source);
			}

			if (utm_campaign !== undefined) {
				$('[data-utm_campaign]').val(utm_campaign);
			}
		},
		_adaCompliance: function _adaCompliance() {
			$('button[role="combobox"]').removeAttr('role');
			$('.filter-option-inner-inner img').attr('alt', $('.filter-option-inner-inner').text());
			$('.hawk-quickSearch input').attr('aria-label', 'Quick Lookup');
			$('select.hawksortby').attr('aria-label', 'Sort By');
			$('a.itemLink.squre-img').attr('aria-label', 'Product image');
			$('.rewards-pages a').attr('aria-label', 'Rewards');
			setTimeout(function () {
				$('.pxFormGenerator iframe').attr('title', 'Request A Quote');
			}, 500);
			setInterval(function () {
				$('.hawk-recommendation-item a.itemLink').attr('aria-label', 'FeaturedItems');
				$('.hawk-recommendation-item a.itemLink img').attr('aria-label', 'FeaturedItems');
			}, 10);
		}
	}
};

export default customMethods;